import React from 'react'
import MuiTable from '../../../Forms/SharedComponents/containers/MuiTable'
import { TABLA_TOTAL_FUERA_DE_GRADO } from '../../../../config/tables'

function LiquidacionFueraDeGradoView () {
  return (
    <MuiTable id={TABLA_TOTAL_FUERA_DE_GRADO} />
  )
}

export default LiquidacionFueraDeGradoView
